import Cookies from "js-cookie";

const dict = {
  // namespaced: true,
  state: {
    dictObj: Cookies.get("dictObj") ? JSON.parse(Cookies.get("dictObj")) : {},
  },
  mutations: {
    SET_DICTOBJ: (state, obj) => {
      const data = { ...state.dictObj, ...obj };
      Cookies.set("dictObj", JSON.stringify(data));
      state.dictObj = data;
    },
  },
  actions: {
    setDictObj({ commit }, obj) {
      commit("SET_DICTOBJ", obj);
    },
  },
};

export default dict;
